import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { memo } from "react";

import {
  chatInlineCode,
  chatMarkdownComponents,
} from "./markdownComponents";

const components = { ...chatMarkdownComponents, code: chatInlineCode };

interface MarkdownContentProps {
  /** The reply, as the agent wrote it. */
  text: string;
}

/**
 * Markdown from a plain string, styled exactly as Ask Focal styles it on a
 * conversation.
 *
 * The conversation chat renders through assistant-ui's `MarkdownTextPrimitive`,
 * which reads the text off the message context and cannot be handed one. The
 * deliverable chat has no such context — its turns come off an SSE controller
 * as strings — so it renders through this instead. Both draw from the same
 * component map, which is what keeps a bulleted list the same shape in both.
 */
const MarkdownContentImpl = ({ text }: MarkdownContentProps) => (
  <div className="aui-md">
    <Markdown remarkPlugins={[remarkGfm]} components={components}>
      {text}
    </Markdown>
  </div>
);

export const MarkdownContent = memo(MarkdownContentImpl);
